<ui-dialog
    [open]="isDeactivateModalOpen"
    (closing)="closeDeactivateModalOpen()"
    confirmationDialog
    header="'applicant-tracker.applicants.discardEmail'"
    primaryButtonLabel="{{ 'applicant-tracker.applicants.discard' | translate }}"
    (primaryButtonPressed)="canNavigateAway()"
    (secondaryButtonPressed)="closeDeactivateModalOpen()"
>
    <p>{{ 'applicant-tracker.applicants.areYouSureYouWantToDiscardThisMessage' | translate }}</p>
</ui-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="applicant-tracker.applicants.emailApplicant" [back]="true"></app-header>

    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <app-applicant-individual-message-form
                    [applicantIndividualMessage]="applicantIndividualMessage"
                    [applicant]="applicant"
                    #applicantIndividualMessageForm
                ></app-applicant-individual-message-form>
                <div class="flex justify-end">
                    <ui-button (click)="onSendTest(applicantIndividualMessageForm)" type="link">{{
                        'applicant-tracker.applicants.sendATest' | translate
                    }}</ui-button>
                    <ui-button (click)="onSave(applicantIndividualMessageForm)" type="primary">{{
                        'applicant-tracker.applicants.send' | translate
                    }}</ui-button>
                </div>
            </div>
        </div>
        <div class="sidebar">
            <app-customization-tokens></app-customization-tokens>
        </div>
    </div>
</div>
